module.exports = __webpack_public_path__ + "static/media/login-bg.be2e9a02.jpg";